import { useListRelatedPersons } from '@hooks/api/related-person';

export function useRelatedPersons(skip?: boolean) {
  const { data, error, loading } = useListRelatedPersons({ skip });

  const powerOfAttorney = data.find((d) => d.isPowerOfAttorney());
  const emergencyContact = data.find((d) => d.isEmergencyContact());
  const legalCounsel = data.find((d) => d.isLegalCounsel());
  const secondaryEmergencyContact = data.find((d) =>
    d.isSecondaryEmergencyContact()
  );

  return {
    data: {
      powerOfAttorney,
      emergencyContact,
      legalCounsel,
      secondaryEmergencyContact,
    },
    error,
    loading,
  };
}
